import { mapState, mapActions, mapMutations } from "vuex";
import { stepTypeInts } from "@/utils/general";

import Table from '@/manzana_library/components/Widgets/Table';
import PromotionTypeIcon from "@/components/promotions/PromotionTypeIcon.vue";
import PromoStatus from "@/components/statistics/general/PromotionStatus.vue";

export default {
  components: {
    Table,
    PromotionTypeIcon,
    PromoStatus
  },

  data() {
    return {
      info: null,
      isLoading: false,
      isError: false
    }
  },

  computed: {
    ...mapState({
      statDateRange: state => state.stat.statDateRange,
      type: state => state.stat.activeType
    }),

    activeIntType() {
      return stepTypeInts[this.activeType];
    }
  },

  watch: {
    statDateRange: {
      immediate: true,
      deep: true,
      handler() {
        this.getStatistics();
      }
    }
  },

  methods: {
    ...mapActions({
      getCampStats: "getCampStats"
    }),
    ...mapMutations({
      setGeneralCirclesData: "setGeneralCirclesData",
      statMutation: "statMutation"
    }),

    async getStatistics() {
      const { params: { id }, query: { taskid, launchid, stepid } } = this.$route;

      try {
        this.isLoading = true;
        this.isError = false;
        this.statMutation({ key: "general", value: true, parentKey: "loadings"});
        this.statMutation({ key: "general", value: false, parentKey: "errors"});

        this.info = await this.getCampStats({
          campuiid: id,
          taskid,
          launchid,
          stepid
        });

        this.setGeneralCirclesData(this.info)
      } catch (e) {
        this.isError = true;
        this.statMutation({ key: "general", value: true, parentKey: "errors"});
        console.log(e);
      } finally {
        this.isLoading = false;
        this.statMutation({ key: "general", value: false, parentKey: "loadings"});
      }
    }
  }
}
